var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2969 7.53906C21.7266 7.77344 22 8.20312 22 8.67188C22 9.41406 21.375 10 20.6328 10H3.32812C2.58594 10 2 9.41406 2 8.67188C2 8.20312 2.23438 7.77344 2.66406 7.53906L11.5312 2.61719C11.8047 2.5 12.1562 2.5 12.4297 2.61719L21.2969 7.53906ZM10.75 7.5C10.75 6.83594 11.2969 6.25 12 6.25C12.6641 6.25 13.25 6.83594 13.25 7.5C13.25 7.73438 13.1719 7.96875 13.0547 8.125H18.5234L12 4.53125L5.4375 8.125H10.9062C10.7891 7.96875 10.75 7.73438 10.75 7.5ZM4.5 11.25H6.375V17.5H8.875V11.25H10.75V17.5H13.25V11.25H15.125V17.5H17.625V11.25H19.5V17.5H19.8125C20.3203 17.5 20.75 17.9297 20.75 18.4375C20.75 18.9844 20.3203 19.375 19.8125 19.375H4.5C3.95312 19.375 3.5625 18.9844 3.5625 18.4375C3.5625 17.9297 3.95312 17.5 4.5 17.5V11.25ZM21.0625 20.625C21.5703 20.625 22 21.0547 22 21.5625C22 22.1094 21.5703 22.5 21.0625 22.5H3.25C2.70312 22.5 2.3125 22.1094 2.3125 21.5625C2.3125 21.0547 2.70312 20.625 3.25 20.625H21.0625Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.08649877.svg";
export { ForwardRef as ReactComponent };